import template from './AppLoader.hbs';

import {BaseView} from '../../../shared/view/BaseView';

/**
 * @class AppLoader
 * @extends BaseView
 */
export class AppLoader extends BaseView {

    get template () {

        return template;
    }

    get className () {

        return 'app-loader';
    }
}


// WEBPACK FOOTER //
// ./shared/view/AppLoader/AppLoader.js